import { PAGE_CODES } from 'constants/pageCodes';
import { lazyWithRetry } from 'utils/chunkLoadRecovery';
import { EnhancedPath } from 'utils/history';

export const UNDERWRITING_ROUTING_PARAMS = {
  ruleId: 'ruleId',
};

export class UnderwritingPaths {
  static rules = new EnhancedPath('/rules');
  static settings = new EnhancedPath('/settings');
  static documentExpirationSettings = new EnhancedPath('/document-expiration-settings');
  static rule = new EnhancedPath(
    `${UnderwritingPaths.rules.path}/:${UNDERWRITING_ROUTING_PARAMS.ruleId}?`,
  );

  static conditionSet = new EnhancedPath('/condition-set');
  static conditions = new EnhancedPath('/conditions');
  static conditionCategories = new EnhancedPath('/condition-categories');
  static priorToTypes = new EnhancedPath('/prior-to-types');
  static searchSynonyms = new EnhancedPath('/search-synonyms');
  static slaGroups = new EnhancedPath('/sla-groups');
}

const routesConfig = {
  settings: {
    layout: {},
  },
  routes: [
    {
      path: UnderwritingPaths.rule.path,
      component: lazyWithRetry(() => import('app/pages/underwriting/rules')),
      pageCode: PAGE_CODES.UNDERWRITING_RULES,
    },
    {
      path: UnderwritingPaths.conditionSet.path,
      component: lazyWithRetry(() => import('app/pages/underwriting/conditionSets')),
      pageCode: PAGE_CODES.UNDERWRITING_CONDITIONS,
    },
    {
      path: UnderwritingPaths.conditions.path,
      component: lazyWithRetry(() => import('app/pages/underwriting/conditions')),
      pageCode: PAGE_CODES.UNDERWRITING_CONDITIONS,
    },
    {
      path: UnderwritingPaths.conditionCategories.path,
      component: lazyWithRetry(() => import('app/pages/underwriting/conditionCategories')),
      pageCode: PAGE_CODES.UNDERWRITING_CONDITION_CATEGORIES,
    },
    {
      path: UnderwritingPaths.priorToTypes.path,
      component: lazyWithRetry(() => import('app/pages/underwriting/priorToTypes')),
      pageCode: PAGE_CODES.UNDERWRITING_CONDITION_CATEGORIES,
    },
    {
      path: UnderwritingPaths.searchSynonyms.path,
      component: lazyWithRetry(() => import('app/pages/underwriting/searchSynonyms')),
      pageCode: PAGE_CODES.UNDERWRITING_CONDITIONS,
    },
    {
      path: UnderwritingPaths.settings.path,
      component: lazyWithRetry(() => import('app/pages/underwriting/settings')),
      pageCode: PAGE_CODES.UNDERWRITING_SETTINGS,
    },
    {
      path: UnderwritingPaths.documentExpirationSettings.path,
      component: lazyWithRetry(() => import('app/pages/underwriting/documentExpirationSettings')),
      pageCode: PAGE_CODES.UNDERWRITING_DOCUMENT_EXPIRATION_SETTINGS,
    },
    {
      path: UnderwritingPaths.slaGroups.path,
      component: lazyWithRetry(() => import('app/pages/underwriting/slaGroups')),
      pageCode: PAGE_CODES.UNDERWRITING_SLA_GROUPS,
    },
  ],
};

export default routesConfig;
